
import styles from "./LoginFooter.module.scss"
import { PRIVACY_POLICY_LINK, TERMS_OF_USE_LINK } from "@constants/common"

const LoginFooter = () => {
  return (
    <div className={styles.loginFooter}>
      <div>©2026 YOUGotaGift.com Ltd.</div>
      <a
        href={
          PRIVACY_POLICY_LINK
        }
        target="_blank" rel="noreferrer"
      >
        Privacy Policy
      </a>
      <a
        href={ TERMS_OF_USE_LINK}
        target="_blank" rel="noreferrer"
      >
        Terms of Use
      </a>
      <img src="/images/pci-image.png" alt="" height={18} />
    </div>
  )
}

export default LoginFooter
